/**
 * TrackCursorLine — 진단 화면의 "지금" 세로 점선.
 *
 * 지속음 트랙의 손잡이 자리를 눈에 보이게 하는 선이다(시안 `882:7938`). **지금 쓰는
 * 곳은 거기 하나다** — 노래 곡선도 잠깐 같은 선을 썼지만(흐르는 축, c28f336) 실기기
 * 판정으로 정적 축이 남으면서 그 화면에서는 커서가 사라졌다(01c954a).
 *
 * 그래도 파일로 남긴다: 대시 간격·굵기가 여기 한 곳에만 적혀 있어야 다음에 "지금" 마커를
 * 쓰는 화면이 생겼을 때 두 번째 리듬이 태어나지 않는다. 자리(`at`)는 프롭이다 — 시안이
 * 화면마다 다른 값을 준다.
 */
interface TrackCursorLineProps {
  /** 트랙 폭 대비 가로 위치(0..1). */
  at: number;
  /** 테스트가 이 선을 집는 이름. 화면마다 달라서 호출자가 준다. */
  testId: string;
  /**
   * 위아래로 페이드를 넣을 때, 선이 온전히 보이는 반폭(%). 지속음은 손잡이가 닿을 수
   * 있는 구간까지만 선을 보여준다. 안 주면 위아래 끝까지 그대로 그린다.
   */
  solidHalfPct?: number;
}

const DASH =
  'repeating-linear-gradient(to bottom, hsl(var(--border)) 0 3px, transparent 3px 12px)';

export const TrackCursorLine = ({
  at,
  testId,
  solidHalfPct,
}: TrackCursorLineProps) => {
  const mask =
    solidHalfPct == null
      ? undefined
      : `linear-gradient(to bottom, transparent, #000 ${50 - solidHalfPct}%, #000 ${50 + solidHalfPct}%, transparent)`;

  return (
    <div
      data-testid={testId}
      aria-hidden="true"
      className="absolute inset-y-0 w-[6px] -translate-x-1/2"
      style={{
        left: `${at * 100}%`,
        backgroundImage: DASH,
        maskImage: mask,
        WebkitMaskImage: mask,
      }}
    />
  );
};
